export const openPdfBlob = (data) => {
  const pdfBlob = new Blob([data], { type: 'application/pdf' })
  const fileURL = URL.createObjectURL(pdfBlob)
  const pdfWindow = window.open()
  if (pdfWindow) {
    pdfWindow.location.href = fileURL
  } else {
    window.location.href = fileURL
  }
}
